import { getCountryCode, getCultureCode, getMarketId, getSaleKey } from 'store/selectors'
import { callPlanet } from './'

export const fetchVersion = state => {
  const saleKey = getSaleKey(state)
  const marketId = getMarketId(state)
  const country = getCountryCode(state)
  const culture = getCultureCode(state)

  return callPlanet(
    `static/content/v2/${saleKey}/version/${marketId}/${country}/${culture}`
  )
}
